import React from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';

import * as DateHelpers from 'helpers/dateHelpers';
import { Portal } from 'components/portal/portal';

export const DatePicker = ({ selected, startDate, endDate, onChange, ...props }: ReactDatePickerProps) => {
  return (
    <ReactDatePicker
      popperContainer={Portal}
      showTimeSelect
      selected={selected}
      startDate={startDate}
      endDate={endDate}
      timeFormat="HH:mm"
      timeIntervals={15}
      onChange={onChange}
      timeCaption="time"
      popperPlacement="bottom-start"
      popperModifiers={{
        flip: {
          enabled: false,
        },
      }}
      dateFormat={DateHelpers.DATE_READABLE_FORMAT}
      {...props}
    />
  );
};
